// uploads

import * as bootstrap from 'bootstrap';
import { DateTime } from 'luxon';
import axios from 'smg/axios';
import * as clipboard from 'smg/clipboard';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import { DownloadURL, Source } from 'smg/download';
import * as formatting from 'smg/formatting';
import * as mime from 'smg/mime';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import * as uploadSMG from 'smg/uploads';
import { PageLoader } from '../account';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    readonly cloudFront: string;
}
declare const window: myWindow;

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const cardTemplate = document.querySelector('#cards') as HTMLTemplateElement;
    const parent = document.querySelector('#uploads-container') as HTMLElement;

    // Upload a file
    const addNew = document.querySelectorAll('.addNew');

    if (addNew.length) {
        addNew.forEach(el => {
            el.addEventListener('click', () => {
                const body = (document.querySelector('#modal-upload-template') as HTMLTemplateElement).content.cloneNode(true) as DocumentFragment;
                const uploadsLabel = body.querySelector('#modal-uploads') as HTMLLabelElement;
                const spinner = uploadsLabel.querySelector('.spinner-border') as HTMLElement;

                const m: Modal = new Modal({
                    outsideClosable: false,
                    title: 'Upload files to your account',
                    body,
                    onSubmit: async () => {
                        const uploadIDs = u.GetUploadIDs();
                        if (uploadIDs.length === 0) {
                            throw new Error('Please provide a file');
                        } else {
                            return axios.patch('/uploads/keep', {
                                'uploadIDs': uploadIDs,
                            }).then(() => {
                                toast.Success(`File${uploadIDs.length === 1 ? '' : 's'} have been uploaded!`);
                                pl.Load();
                            });
                        }
                    },
                });

                const u = new uploadSMG.Uploader(uploadsLabel, {
                    confirmBtn: m.Element.querySelector('[type="submit"]') as HTMLButtonElement,
                    thumbnails: document.querySelector('#modal-uploads-thumbnails') as HTMLElement,
                    thumbnailHeight: '5rem',
                    thumbnailMaxHeight: 'auto',
                    start: () => spinner.classList.remove('d-none'),
                    stop: () => spinner.classList.add('d-none'),
                    onchange: () => {
                        const errorEl = document.querySelector('.modal-error') as HTMLElement;
                        errorEl.classList.add('d-none');
                    },
                });
            });
        });
    }

    const pl: PageLoader<models.Upload> = new PageLoader<models.Upload>({
        afterLoad: () => {
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        parent: document.querySelector('#uploads-container') as HTMLElement,
        get: () => axios.get<hyejoo.Uploads>('/uploads', {
            params: {
                'sort': pl.Sort(),
                'max': pl.CurrentPageSize(),
                'p': pl.CurrentPage(),
                'q': pl.Search(),
            },
        }).then(resp => ({ rows: resp.data.uploads, nextPage: resp.data.nextPage })),
        draw: uploads => {
            const card = template.Clone(cardTemplate);

            // Name
            const nameEl = card.querySelectorAll('.upload-name');
            const name = uploads.name;

            if (nameEl) {
                nameEl.forEach(el => {
                    el.textContent = name ?? '';
                });
            }
            // nameEl.textContent = name ?? '';

            // Url
            const urlEl = card.querySelector('.upload-link') as HTMLElement;
            const a = document.createElement('a') as HTMLAnchorElement;
            const url = `${window.cloudFront}/${uploads.key ?? ''}`;

            if (urlEl) {
                a.textContent = url;
                a.href = url;
                a.setAttribute('target', '_blank');
                if (uploads.mime && mime.WebSafeMime(uploads.mime)) {
                    a.setAttribute('data-fancybox', String(uploads.id));
                }
                urlEl.append(a);
            }

            // File Size
            const sizeEl = card.querySelectorAll('.file-size');

            if (sizeEl) {
                // sizeEl.textContent = formatting.HumanFileSize(uploads.size ?? 0);
                sizeEl.forEach(el => {
                    el.textContent = formatting.HumanFileSize(uploads.size ?? 0);
                });
            }

            // Date created
            const dateEl = card.querySelectorAll('.date-created');

            if (dateEl) {
                // dateEl.textContent = DateTime.fromISO(uploads.created ?? '').toLocaleString(DateTime.DATE_SHORT);
                dateEl.forEach(el => {
                    el.textContent = DateTime.fromISO(uploads.created ?? '').toLocaleString(DateTime.DATE_SHORT);
                });
            }

            // Download
            const downloadEl = card.querySelector('.download-button') as HTMLAnchorElement;

            if (downloadEl) {
                const s: Source = {
                    url: url,
                };
                downloadEl.addEventListener('click', async () => {
                    await DownloadURL(name ?? '', s);
                });
            }

            // Copy link
            const copyLink = card.querySelector('.copy-link') as HTMLButtonElement;

            if (copyLink) {
                copyLink.addEventListener('click', () => {
                    clipboard.Copy(`${window.cloudFront}/${uploads.key ?? ''}`);
                    const t = new bootstrap.Tooltip(copyLink, {
                        title: 'Copied!',
                        trigger: 'manual',
                    });
                    t.show();
                    setTimeout(() => t.dispose(), 2000);
                });
            }

            // Thumbnail
            const thumbContainer = card.querySelector('.page-thumbnail') as HTMLElement;

            if (thumbContainer) {
                const img = document.createElement('img') as HTMLImageElement;
                const a = document.createElement('a');

                img.style.maxHeight = '5rem';
                img.style.maxWidth = '5rem';
                void uploadSMG.Load(img, url, name ?? '');

                a.setAttribute('data-fancybox', 'uploads');
                a.href = url;

                a.append(img);
                thumbContainer.append(a);
            }

            return card;
        },
    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.Load();
}